import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    overflow: 'hidden unset'
  },

  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60px',
    color: theme.palette.textLightFaded,
    fontSize: theme.size.lg
  },

  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  number: {
    color: theme.palette.textLightFaded
  },

  cost: {
    fontFamily: 'monospace'
  },

  pdf: {
    display: 'flex',
    alignItems: 'center',

    '& img': {
      height: '32px',
      width: '32px'
    }
  }
}))

export default useStyles
